










import {
  LayoutConfig,
  LayoutDataSet,
} from '@/uikit/components/AppDefaultLayout/types/LayoutTypes';

export default {
  /// добавлять данные или параметры, в
  /// exampleCfgSet
  /// больше тут никаких пропсов не будет
  props: {
    cfg: {
      type: Object as () => LayoutConfig['footer']['sections']['siteNavigationList'],
      required: true,
    },
    data: {
      type: Array as () => LayoutDataSet['siteNavigationList'],
    },
  },
  computed: {
    rows(): any {
      let rowsLength = Math.ceil(this.data.length / 3);
      let ret: any = [];
      for (let i = 0; i < rowsLength; i++) {
        let add: any = {};
        add.items = this.data.slice(
          i * 3,
          Math.min(i * 3 + 3, this.data.length)
        );
        ret.push(add);
      }
      return ret;
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/components/sections/siteNavigationList/SiteNavigationList.vue